<nav *ngIf="!hide" style="max-width:none; min-width: 50rem;">
  <div class="menu">
    <div class="homeandlogo">
      <!-- HOME ICON -->
      <!-- <li class="logo">
        <button (click)="goback()">
          <mat-icon>home</mat-icon>
        </button>
      </li> -->



      <!-- LOGO-->
      <div class="item">
        <button class="logo" (click)="goback()">Happy Again</button>
      </div>

      <!-- SEPARATOR -->
      <div class="separator"></div>

      <!-- HOME -->
      <div class="item">
        <button class="home" (click)="goback()">HOME</button>
      </div>

      <!-- SEPARATOR2 -->
      <div class="separator2"></div>

      <!-- ADMIN AREA-->
        <!-- HOME -->
      <div *ngIf="isAlsoAdmin" class="item">
        <button class="home" (click)="adminArea()">ADMIN AREA</button>
      </div>

      <!-- HOME MOBILE-->
      <div class="itemMobile">
        <button class="homeMobile" (click)="goback()"><mat-icon homeIcon>home</mat-icon></button>
        <i class="fas fa-caret-down"></i>
      </div>


      <!-- SEPARATOR2 -->
      <div class="separator2"></div>

      <!-- DISPLAYED LANGUAGE-->
      <div class="item">
        <button class="language" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
          (click)="menuTrigger.openMenu()">
          <!-- <img src="/assets/flags/{{lan}}.png" class="flag" width="28" height="14" alt=""> -->
         {{language[lan]}} <span>&#8893;</span>

         <!-- <mat-icon >arrow_drop_down</mat-icon> -->
          
        </button>
      </div>
      <!-- AVAILABLE LANGUAGES -->
      <mat-menu #menu="matMenu" [overlapTrigger]="false">
        <!-- <span (mouseleave)="menuTrigger.closeMenu()"> -->
        <div *ngFor="let language of languages">
          <button mat-menu-item (click)="setLanguage(language.abb)"> {{language.full}}</button>
        </div>
        <!-- </span> -->
      </mat-menu>
    </div>

    <!-- LOGIN BUTTON -->
    <div *ngIf="!isLogged" class="item">
      <button class="login" (click)="logOn()">Login</button>
    </div>

    <!-- SIGN UP / REGISTER BUTTON-->
    <div *ngIf="!isLogged" class="item">
      <button class="register" (click)="register()">{{'HOME_REGISTER' | translate}}</button>
    </div>

    <!-- LOGOUT BUTTON -->
    <div *ngIf="isLogged" class="item" (click)="logOut()">
      <button class="logout" (click)="logOut()">Logout</button>
    </div>

  </div>
</nav>